import { motion } from "framer-motion";
import { MapPin, RefreshCw } from "lucide-react";
import { useT } from "@/i18n";
import { LANGS, PINS, LANG_TEXT, flagUrl } from "@/components/languages/content";

export const WorldScene = ({ target, setTarget }) => {
  const { lang } = useT();
  const tx = LANG_TEXT[lang];
  return (
    <div>
      <h2 className="text-center font-fredoka text-3xl sm:text-5xl lg:text-6xl font-bold leading-tight" data-testid="lang-title">
        <span className="bubble-text text-blue-800" style={{ WebkitTextStroke: "3px white" }}>{tx.titleA}</span>
        <br />
        <span className="bubble-text text-orange-400" style={{ WebkitTextStroke: "3px white" }}>{tx.titleB}</span>
      </h2>
      <div className="relative mt-5 rounded-[2rem] overflow-hidden border-4 border-white shadow-xl" data-testid="lang-world-scene">
        <img src="/img/lang-scene.webp" alt="Lumi y Spark con el mapa del mundo" className="w-full h-auto block" />
        {PINS.map((p) => (
          <button
            key={p.lang}
            type="button"
            onClick={() => setTarget(p.lang)}
            className={`absolute -translate-x-1/2 -translate-y-1/2 w-[13%] h-[13%] rounded-2xl transition-all ${target === p.lang ? "ring-4 ring-yellow-300 bg-yellow-200/30" : "hover:bg-white/30"}`}
            style={{ left: p.left, top: p.top }}
            aria-label={p.lang}
            data-testid={`map-pin-${p.lang}`}
          />
        ))}
        <span className="absolute bottom-3 left-1/2 -translate-x-1/2 bg-white/90 rounded-full px-3 py-1 text-xs sm:text-sm font-bold text-blue-900 inline-flex items-center gap-1 shadow">
          <MapPin className="w-4 h-4 text-rose-500" /> {tx.tapMap}
        </span>
      </div>
    </div>
  );
};

export const LangButtons = ({ target, setTarget }) => {
  const { lang } = useT();
  return (
    <div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {LANGS.map((l) => (
          <motion.button
            key={l.id}
            type="button"
            whileTap={{ scale: 0.94 }}
            onClick={() => setTarget(l.id)}
            className={`${l.btn} rounded-full border-4 ${target === l.id ? "border-yellow-300 ring-4 ring-yellow-200" : "border-white"} shadow-lg pl-2 pr-5 py-2 flex items-center gap-3 text-white font-fredoka font-bold text-lg sm:text-2xl`}
            data-testid={`lang-btn-${l.id}`}
          >
            <img src={flagUrl(l.flag)} alt="" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full object-cover border-2 border-white" />
            {l.label}
          </motion.button>
        ))}
      </div>
      <div className="mt-4 text-center">
        <p className="inline-flex items-center gap-2 bg-white rounded-full px-5 py-2 font-fredoka font-bold text-blue-800 text-base sm:text-xl shadow" data-testid="lang-change-note">
          <RefreshCw className="w-5 h-5 text-blue-600" /> {LANG_TEXT[lang].change}
        </p>
      </div>
    </div>
  );
};

export const HelloBanner = () => (
  <div className="bg-gradient-to-r from-yellow-200 via-yellow-300 to-yellow-200 rounded-full border-4 border-white shadow-xl px-4 sm:px-8 py-3 flex flex-wrap items-center justify-center gap-x-3 gap-y-1" data-testid="lang-hello-banner">
    <img src="/img/languages.webp" alt="" className="w-10 sm:w-14" />
    {LANGS.map((l, i) => (
      <span key={l.id} className={`font-fredoka font-bold text-2xl sm:text-4xl ${l.helloColor}`}>
        {l.hello}{i < LANGS.length - 1 && <span className="text-blue-900 mx-2">·</span>}
      </span>
    ))}
  </div>
);
